import { getAccessToken } from "./utils";
import axios from "axios";
import moment from "moment-timezone";
import { getUrl } from "./urls";
// import

export const FETCH_DOWNLOADS_LIST = "FETCH_DOWNLOADS_LIST";

function getTimeZone() {
    var offset = new Date().getTimezoneOffset(),
        o = Math.abs(offset);
    return (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
}

export const fetchDownloadsList = () => {
    let url = `${getUrl("download_list")}?access-token=${getAccessToken()}`;
    let timeZone = getTimeZone();
    let req = axios({
        method: "post",
        url: url,
        headers: {
            "Content-Type": "application/json",
        },
        data: {
            timeZone,
        },
    })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_DOWNLOADS_LIST,
        payload: req,
    };
};
